import { DocumentNode, gql } from '@apollo/client';
import { Box, Divider, HStack, Link, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { PinIcon } from '@/imports/ui/chakra/customIcon';

import { PinnedHeader_PostFragment } from './graphql-types/PinnedHeader_PostFragment';

const POST_FRAGMENT = gql`
  fragment PinnedHeader_PostFragment on PostV2 {
    _id
    pinned
    group {
      _id
      name
    }
  }
`;

export const PinnedHeader: React.FC<{
  post: PinnedHeader_PostFragment;
}> & {
  postFragment: DocumentNode;
} = ({ post }) => {
  const { canAccessCommunityAndGroupFeed } = usePermissions();

  if (!post.pinned || !post.group?.name) {
    return null;
  }

  return (
    <Box px="4" pt="4">
      <HStack alignItems="center">
        <PinIcon />
        <Text textStyle="compact" as="span" flexGrow="1">
          Pinned to
          {canAccessCommunityAndGroupFeed ? (
            <Link
              as={NextLink}
              href={`/community/groups/${post.group._id}/activity`}
              ml="1"
            >
              {post.group.name}
            </Link>
          ) : (
            <Text as="span" ml="1">
              {post.group.name}
            </Text>
          )}
        </Text>
      </HStack>
      <Divider pt="4" />
    </Box>
  );
};

PinnedHeader.postFragment = POST_FRAGMENT;
